<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How do I find the book I need to buy?</h1>
			<p v-if="this.$globs['institute_info']['id'] != undefined">
				We recommend that you search for the course you are enrolled in to ensure you get the right item
			</p>
			<search-course v-if="this.$globs['institute_info']['id'] != undefined" @selected="courseSelected"></search-course>

			<p>
				If you are unable to find your course, but have the ISBN you can search here. If your book is not attached to a course you must click on "show
				all
				results"
			</p>
			<search-book @selected="bookSelected" show-all></search-book>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import SearchCourse from './../components/SearchCourse'
	import SearchBook from './../components/SearchBook'

	export default {
		name: "HowToFindBook",

		components: {
			BaseNavLinks,
			SearchCourse,
			SearchBook,
		},

		methods: {
			courseSelected(val) {
				if (!val['id']) return;
				document.location.href = `/institutional/index.php?action=browse#books/${val['id']}`;
			},

			bookSelected(val) {
				if (!val['result']['isbn']) return;
				if (val['result']['isbn'] === '-1') {
					document.location.href = `/fastsearch2.php?s=${val['query']}`;
				} else {
					document.location.href = `/book/${val['result']['isbn']}/`;
				}
			},
		}
	}
</script>

<style scoped>

</style>